import React, { Component } from "react";

// Custom Module
import request from "../../../lib/requester";
import _ from "lodash";

// Downloaded Module
import { Loader } from "react-overlay-loader";
import ReactTable from "react-table";
import "react-table/react-table.css";

class ListMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(window.localStorage.getItem("is_user")),
      selectedBranchId: "",
      selectedBranchCode: "",
      lov_branch: [],
      dataTable: [],
      page: 1,
      loading: false,
      searchCustomer: ''
    };
  }

  componentDidMount = () => {
    this.dataBranch();
  };

  getList = async () => {
    let { user } = this.state
    let customerName = encodeURI(this.state.searchCustomer)

    let userBranch = user.branch.map((item, index) => {
      return item.org_name
    })
    userBranch = userBranch.join(",")

    let selectedBranch = user.origin === 'HO' ? this.state.selectedBranchCode : userBranch
    let url = "/api/traces_chd/v1/recommendation/list-master?branch=" + selectedBranch + "&page=" + this.state.page + "&customer=" + customerName;
    this.setState({ loading: true });
    request.getCHD(url, {
      success: function (response) {
        let { data } = response.data;
        this.setState({
          dataTable: data.data,
          totalPage: data.totalPage,
          loading: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  dataBranch = () => {
    let { user } = this.state;
    let url = "/api/traces_chd/v1/recommendation/branch-subdist";
    this.setState({ loading: true })
    request.postCHD(url, {}, {
      success: function (response) {
        let { data } = response.data;
        let find = _.find(data, function (o) {
          return o.org_id === user.org_id;
        });

        // If not found, then push to LOV
        if (!find) {
          data.push({
            org_id: user.org_id,
            org_initial: user.org_initial,
            org_name: user.org_name,
          });
        }

        this.setState({
          lov_branch: response.data.data || [],
          selectedBranchCode: user.origin !== 'HO' ? user.org_name : '',
          selectedBranchId: user.origin !== 'HO' ? user.org_id : '',
          loading: false
        });

        if (user.origin !== 'HO') {
          let app = this
          window.setTimeout(() => {
            app.getList()
          }, 200)
        }
      }.bind(this),
      error: function (e) {
        console.log(e);
      }.bind(this),
    });
  };

  handleChangeBranch = (e) => {
    let value = e.target.value;
    this.setState({ selectedBranchId: value, selectedBranchCode: value });
  };

  handleChangePage = (e) => {
    let value = e.target.value
    this.setState({ page: value })
    let app = this
    window.setTimeout(() => {
      app.getList()
    }, 200)
  }

  renderPagination = () => {
    let { totalPage } = this.state
    let totalArray = []
    for(var i = 0; i < totalPage; i++) {
      totalArray.push({ seq: i + 1 })
    }

    return(
      <div className="row mt-2">
        <div className="col-md-2">
          <div className="form-group row">
            <label className="col-md-4 mt-1">Page:</label>
            <select className="col-md-8 form-control form-control-sm" value={this.state.page} onChange={this.handleChangePage.bind(this)}>
              {
                totalArray.map((item, index) => (
                  <option value={item.seq}>{item.seq}</option>
                ))
              }
            </select>
          </div>
        </div>
      </div>
    )
  }
  renderBranch = () => {
    let { user } = this.state
    return (
      <div className="row mb-2">
        <div className={"col-md-3" + (user.origin !== 'HO' ? ' d-none' : '')}>
            <label className="">Branch</label>
            <select
              className="form-control"
              value={this.state.selectedBranchCode}
              onChange={this.handleChangeBranch.bind(this)}
              disabled={user.origin !== 'HO' ? true : false }
            >
              <option value="">- Select Branch -</option>
              <option value={"ALL"}>ALL</option>
              {this.state.lov_branch.map((item, index) => (
                <option value={item.BRANCH_DESC}>{item.BRANCH_DESC}</option>
              ))}
            </select>
        </div>
        <div className="col-md-3">
            <label className="">Outlet Name Subdist</label>
            <input type="text" className="form-control" name="CUSTOMER_NAME_SUBDIST" value={this.state.searchCustomer} onChange={this.handleChangeSearch.bind(this)} />
        </div>
        <div className="col-md-2 mt-3">
          <button className="btn btn-primary mt-3" onClick={this.handleSearch.bind(this)}><i className="fa fa-search"></i> Search</button>
        </div>
      </div>
    );
  };

  handleSearch = () => {
    this.setState({ page: 1})
    let app = this

    window.setTimeout(() => {
      app.getList()
    }, 100)
  }

  handleChangeSearch = (e) => {
    let value = e.target.value
    this.setState({ searchCustomer: value })
  }

  renderTable = () => {
    let app = this;
    const data = {
      columns: [
        {
          Header: "OUTLET ID AAM",
          accessor: "OUTLET_ID_AAM",
          filterable: true,
          width: 200,
        },
        {
          Header: "OUTLET CODE AAM",
          accessor: "OUTLET_CODE_AAM",
          filterable: true,
          width: 200,
        },
        {
          Header: "OUTLET NAME AAM",
          accessor: "OUTLET_NAME_AAM",
          filterable: true,
          width: 300,
        },
        {
          Header: "OUTLET ID SUBDIST",
          accessor: "OUTLET_ID_SUBDIST",
          filterable: true,
          width: 200,
        },
        {
          Header: "OUTLET CODE SUBDIST",
          accessor: "OUTLET_CODE_SUBDIST",
          filterable: true,
          width: 200,
        },
        {
          Header: "OUTLET NAME SUBDIST",
          accessor: "OUTLET_NAME_SUBDIST",
          filterable: true,
          width: 300,
        },
        {
          Header: "BRANCH DESC",
          accessor: "BRANCH_DESC",
          filterable: true,
          width: 200,
        },
        {
          Header: "CITY",
          accessor: "CITY",
          filterable: true,
        },
        {
          Header: "RAYON",
          accessor: "RAYON",
          filterable: true,
        },
        {
          Header: "CHANNEL OTC",
          accessor: "CHANNEL_OTC",
          filterable: true,
          width: 200,
        },
        {
          Header: "GROUP MODERN",
          accessor: "GROUP_MODERN",
          filterable: true,
          width: 300,
        },
        {
          Header: "PILAR",
          accessor: "PILAR",
          filterable: true,
        },
        {
          Header: "FLAG CUSTOMER",
          accessor: "FLAG_CUSTOMER",
          filterable: true,
          width: 200,
        },
        {
          Header: "FLAG MAPPING OUTLET",
          accessor: "FLAG_MAPPING_OUTLET",
          filterable: true,
          width: 200,
        },
        {
          Header: "FLAG MAPPING RAYON",
          accessor: "FLAG_MAPPING_RAYON",
          filterable: true,
          width: 200,
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="-striped -highlight"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={15}
        showPagination={false}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
        getTrProps={(state, row) => {
          return {
            onClick: function () {
              let data = row.original
              window.localStorage.setItem('data_outlet', JSON.stringify(data))
              app.props.history.push(
                "/admin/recommendation-chd/detail-master/" +
                  row.original.OUTLET_ID_SUBDIST +
                  "/" +
                  row.original.SUBDIST_ID
              );
            },
          };
        }}
      />
    );
  };

  renderMessage = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="alert alert-warning">
            <i className="fa fa-exclamation-triangle"></i> Click row to select
            outlet
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">
                    <i className="fa fa-file" /> List Master
                  </div>
                  <div className="card-body">
                    {this.renderBranch()}
                    {this.renderMessage()}
                    {this.renderTable()}
                    {this.renderPagination()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default ListMaster;
